import { render, staticRenderFns } from "./DialogDeleteUser.vue?vue&type=template&id=41845fc9"
import script from "./DialogDeleteUser.vue?vue&type=script&lang=js"
export * from "./DialogDeleteUser.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/dev.ideabuddy.com/public_html/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('41845fc9')) {
      api.createRecord('41845fc9', component.options)
    } else {
      api.reload('41845fc9', component.options)
    }
    module.hot.accept("./DialogDeleteUser.vue?vue&type=template&id=41845fc9", function () {
      api.rerender('41845fc9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Settings/components/Dialogs/DialogDeleteUser.vue"
export default component.exports